"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityType = void 0;
var create_entity_1 = require("../../utils/create-entity");
var entity_type_details_layout_1 = require("../../components/entities/entity-type-details-layout");
var utils_1 = require("../../utils");
exports.EntityType = {
  name: 'EntityType',
  type: 'taxonomy',
  autoRoutes: ['list', 'create', 'update', 'details'],
  table: {
    fieldNames: ["info", "internalName", "views"],
    fields: {
      info: {
        title: 'Name',
        weight: 1
      },
      internalName: {
        title: 'Internal Name'
      },
      views: {
        title: 'Views'
      }
    }
  },
  list: {
    resultsVariant: "table"
  },
  details: {
    queryFields: (0, utils_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ...EntityValueFields\n      views {\n        ...EntityValueFields\n        layout { ...EntityValueFields }\n        type { ...EntityValueFields }\n\n        slices {\n          id name slug label title pretitle subtitle disabled \n          intro { ...ContentNodeFields }\n          outro { ...ContentNodeFields }\n          layout { ...EntityValueFields }\n\n          viewTarget { ...EntityValueFields }\n          subviewTarget { ...EntityValueFields }\n\n          indicators { ...EntityValueFields }\n          indicatorGroups { ...EntityValueFields }\n \n          bodyFontType { ...EntityValueFields }\n          headerFontType { ...EntityValueFields }\n          \n          connectedEntities { ...EntityValueFields }\n          entityLayout { ...EntityValueFields }\n          \n          themeMode { ...EntityValueFields }\n          content { ...ContentNodeFields }\n          backgroundImages { ...EntityValueFields }\n          videos { ...EntityValueFields }\n          images { ...EntityValueFields }\n          color { ...EntityValueFields value darkValue }\n          pages { ...EntityValueFields }\n          people { ...EntityValueFields path }\n          links { ...EntityValueFields }\n          organisations { ...EntityValueFields }\n          feedEntries { ...EntityValueFields }\n          backgroundColor { ...EntityValueFields value darkValue }\n          files { ...FileAssetValueFields }\n          icons { ...EntityValueFields }\n\n          challenges { ...EntityValueFields }\n          keyIssues { ...EntityValueFields }\n          topics { ...EntityValueFields }\n          subTopics { ...EntityValueFields }\n          trends { ...EntityValueFields }\n\n          blocks {\n            id name slug title subtitle\n            content { id text }\n            layout { ...EntityValueFields }\n            links { ...EntityValueFields }\n            page { ...EntityValueFields }\n            image { ...EntityValueFields }\n            color { ...EntityValueFields value darkValue }\n          }\n        }\n      }\n    "], ["\n      ...EntityValueFields\n      views {\n        ...EntityValueFields\n        layout { ...EntityValueFields }\n        type { ...EntityValueFields }\n\n        slices {\n          id name slug label title pretitle subtitle disabled \n          intro { ...ContentNodeFields }\n          outro { ...ContentNodeFields }\n          layout { ...EntityValueFields }\n\n          viewTarget { ...EntityValueFields }\n          subviewTarget { ...EntityValueFields }\n\n          indicators { ...EntityValueFields }\n          indicatorGroups { ...EntityValueFields }\n \n          bodyFontType { ...EntityValueFields }\n          headerFontType { ...EntityValueFields }\n          \n          connectedEntities { ...EntityValueFields }\n          entityLayout { ...EntityValueFields }\n          \n          themeMode { ...EntityValueFields }\n          content { ...ContentNodeFields }\n          backgroundImages { ...EntityValueFields }\n          videos { ...EntityValueFields }\n          images { ...EntityValueFields }\n          color { ...EntityValueFields value darkValue }\n          pages { ...EntityValueFields }\n          people { ...EntityValueFields path }\n          links { ...EntityValueFields }\n          organisations { ...EntityValueFields }\n          feedEntries { ...EntityValueFields }\n          backgroundColor { ...EntityValueFields value darkValue }\n          files { ...FileAssetValueFields }\n          icons { ...EntityValueFields }\n\n          challenges { ...EntityValueFields }\n          keyIssues { ...EntityValueFields }\n          topics { ...EntityValueFields }\n          subTopics { ...EntityValueFields }\n          trends { ...EntityValueFields }\n\n          blocks {\n            id name slug title subtitle\n            content { id text }\n            layout { ...EntityValueFields }\n            links { ...EntityValueFields }\n            page { ...EntityValueFields }\n            image { ...EntityValueFields }\n            color { ...EntityValueFields value darkValue }\n          }\n        }\n      }\n    "])))
  },
  components: {
    details: entity_type_details_layout_1.EntityTypeDetailsLayout
  },
  form: {
    modal: {
      maxWidth: "600px"
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'views'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      label: {
        type: 'text',
        updateArgs: 'auto: false',
        description: "Provide an alternative label used for displaying this {{ENTITY_TYPE}}. If not provided, this will be derived from the name."
      },
      pluralLabel: {
        type: 'text',
        updateArgs: 'auto: false',
        description: "Provide an alternative label used for displaying the plural form of this {{ENTITY_TYPE}}. If not provided, this will be auto-derived from the name."
      },
      internalName: {
        type: 'text',
        monospace: true,
        updateArgs: 'auto: false',
        recommended: false,
        description: "Specify the internal platform name for this entity type. If you are unsure what this is, leave this blank or contact support."
      },
      description: {
        type: 'longText'
      },
      icon: {
        type: 'linked',
        entityTypeName: 'Icon',
        fieldSet: 'overview'
      },
      useAi: {
        type: 'boolean',
        label: "Use AI",
        description: "Check this box to include AI features for this {{ENTITY_TYPE}} (e.g. includes an AI Tab view for the entity details layout)",
        fieldSet: 'overview'
      },
      views: {
        type: 'linkedTable',
        entityTypeName: 'View',
        description: "Setup {{VIEWS}} for this {{ENTITY_TYPE}} - views are a way to dynamically build the user interface for instances of this {{ENTITY_TYPE}}. {{VIEWS}} can have their own {{SLICES}}, and those {{SLICES}} can contain field placeholders which will fill in the values of those fields from records based on this {{ENTITY_TYPE}}.",
        fieldSet: 'views'
      }
    })
  }
};
var templateObject_1;